import {BASE_URL, HandleErrorResponse} from "./common";

export const fetchApprovers = async (accountId: string, roleName: string) => {
    const endpoint = `${BASE_URL}/approvers?account_id=${accountId}&role_name=${roleName}`;

    try {
        const response = await fetch(endpoint, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        });

        if (!response.ok) {
            await HandleErrorResponse(response);
        }

        return response.json();
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
}